export enum FundraiserType {
  ONE_TIME_DONATION = 0,
  RECURRING_DONATION = 1,
  LOAN = 2,
}
